/**
 * Resolve a stored asset reference into a renderable URL.
 *
 * Upload responses return a bare S3 key like `logos/abc.png`. Legacy rows may
 * already hold full or schemeless URLs (`https://...`, `//...`). Nginx proxies
 * `/assets/{key}` to the public assets bucket, so bare keys just need the
 * prefix.
 */
export const assetUrl = (
  value: null | string | undefined
): string | undefined => {
  if (!value) return undefined;

  if (/^(https?:)?\/\//i.test(value) || value.startsWith('/')) return value;

  return `/assets/${value}`;
};
